"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageInstanceSchemaProperties = exports.ZapierPackageInstanceSchema = exports.PackageInstanceSchema = exports.PackageInstanceItemSchema = exports.OnTrackHistoryType = exports.PackageTrackingStatusTypes = exports.PackageInstancePaymentSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const billing_rate_schema_1 = require("./billing-rate-schema");
const client_schema_1 = require("./client-schema");
const package_schema_1 = require("./package-schema");
const package_schema_2 = require("./package-schema");
const price_schema_1 = require("./price-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const tier_schema_1 = require("./tier-schema");
const PackagePaymentStatusEnum = zod_1.z.enum([
    "paid",
    "failed",
    "scheduled",
    "shared",
    "cancelled",
]);
const PackageInstanceStatusEnum = zod_1.z.enum([
    "active",
    "deleted",
    "completed",
    "blocked",
    "scheduled",
    "ordered",
    "processing",
    "paused",
]);
const PackageInvoiceOptionEnum = zod_1.z.enum([
    "none",
    "draft",
    "shared-via-email",
    "scheduled",
    "charge",
]);
exports.PackageInstancePaymentSchema = zod_1.z.object({
    invoiceId: zod_1.z.string(),
    dueDate: zod_1.z.date(),
    paidAt: zod_1.z.date().optional(),
    title: zod_1.z.string(),
    status: PackagePaymentStatusEnum,
    currency: zod_1.z.string(),
    amount: zod_1.z.number(),
    paymentIntentId: zod_1.z.string().optional(),
});
exports.PackageTrackingStatusTypes = zod_1.z.enum([
    "onTrack",
    "atRisk",
    "offTrack",
    "disabled",
    "paused",
    "completed",
]);
exports.OnTrackHistoryType = zod_1.z.object({
    status: exports.PackageTrackingStatusTypes,
    date: zod_1.z.date(),
    action: zod_1.z.enum(["updatedStatus", "sentNotification"]),
    smartActionId: zod_1.z.string().optional(),
});
exports.PackageInstanceItemSchema = zod_1.z.object({
    productId: zod_1.z.string().optional(),
    schedulerId: zod_1.z.string(),
    quantity: zod_1.z.number(),
    order: zod_1.z.number().optional(),
    suggestedFrequency: package_schema_1.PackageFrequencySchema.optional(),
    usagePricing: package_schema_2.UsagePackagePricingSchema.optional(),
    billingRate: billing_rate_schema_1.BillingRateSchema.nullable().optional(),
    memberIds: zod_1.z.string().array().optional(),
    curriculum: zod_1.z.boolean().optional(),
    isUnlimited: zod_1.z.boolean().optional(),
});
exports.PackageInstanceSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    icon: zod_1.z.string(),
    items: zod_1.z.array(exports.PackageInstanceItemSchema),
    payments: zod_1.z.array(exports.PackageInstancePaymentSchema),
    packageId: zod_1.z.string(),
    status: PackageInstanceStatusEnum,
    isAssignedByCoach: zod_1.z.boolean().optional(),
    invoiceOption: PackageInvoiceOptionEnum.optional(),
    scheduledSmartActions: zod_1.z.string().array().optional(),
    coachUserId: zod_1.z.string(),
    clientId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    billingRate: billing_rate_schema_1.BillingRateSchema.optional(),
    packageBillingRateType: package_schema_1.PackageBillingRateTypeSchema.optional().nullable(),
    contentType: package_schema_1.PackageContentTypeSchema.optional(),
    timeType: package_schema_1.PackageTimeTypeSchema.nullable().optional(),
    packageType: package_schema_1.PackageTypeSchema.optional(),
    frequency: package_schema_1.PackageFrequencySchema.nullable().optional(),
    customSubscriptionId: zod_1.z.string().nullable().optional(),
    resetDate: zod_1.z.date().nullable().optional(),
    currentCycle: zod_1.z.number().optional(),
    rollOver: zod_1.z.boolean().optional(),
    cyclePauses: zod_1.z
        .record(zod_1.z.string(), zod_1.z.array(zod_1.z.object({
        startDate: zod_1.z.date(),
        endDate: zod_1.z.date().optional(),
        cycleEndDate: zod_1.z.date().optional(),
    })))
        .optional(),
    cycleExtensions: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional(),
    totalSessions: zod_1.z.number().nullable().optional(),
    distributeSessions: zod_1.z.boolean().optional(),
    autocomplete: zod_1.z.boolean().optional(),
    startDate: zod_1.z.date().optional(),
    acceptedOutcomes: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    autoCancelOutcome: zod_1.z.boolean().optional().nullable(),
    setupIntentId: zod_1.z.string().optional(),
    paymentOption: package_schema_1.PackagePaymentOptionSchema.optional(),
    paymentSettings: zod_1.z
        .object({
        taxTypeId: zod_1.z.string(),
        currency: zod_1.z.string(),
    })
        .optional(),
    usageInvoicing: package_schema_2.UsagePackageInvoicingSchema.optional().nullable(),
    endDate: zod_1.z.date().optional().nullable(),
    locked: zod_1.z.boolean().optional(),
    participants: zod_1.z.string().array().optional(),
    supervisors: zod_1.z.string().array().optional(),
    organizationSettings: zod_1.z
        .object({
        hideNotesAndFormsFromManagers: zod_1.z.boolean().optional(),
    })
        .optional(),
    depositRule: zod_1.z
        .enum(["start-of-engagement", "end-of-engagement", "no-deposit"])
        .optional(),
    invoiceId: zod_1.z.string().optional(),
    onTrackRules: package_schema_1.PackageOnTrackRulesType.nullable().optional(),
    onTrackStatus: exports.PackageTrackingStatusTypes.optional().nullable(),
    onTrackHistory: zod_1.z.array(exports.OnTrackHistoryType).optional(),
    onTrackNotifications: package_schema_1.OnTrackNotificationsType.optional().nullable(),
    onTrackEnabled: zod_1.z.boolean().optional(),
    tier: tier_schema_1.TierSchema.optional(),
    price: price_schema_1.PriceSchema.optional(),
    deletedAt: zod_1.z.date().optional(),
    deletedBy: zod_1.z.string().optional(),
    expiration: zod_1.z.date().optional().nullable(),
});
exports.ZapierPackageInstanceSchema = base_schema_1.BaseSchema.extend({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    items: zod_1.z.array(zod_1.z.object({
        schedulerTitle: zod_1.z.string(),
        quantity: zod_1.z.number(),
    })),
    payments: zod_1.z.number(),
    client: client_schema_1.ZapierClientSchema,
});
exports.PackageInstanceSchemaProperties = {
    collectionName: "packageInstances",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=package-instance-schema.js.map